import type { Tab } from "../route.ts";

interface Props {
  readonly active: Tab;
  readonly onNavigate: (tab: Tab) => void;
}

const TABS: readonly {
  readonly tab: Tab;
  readonly label: string;
  readonly icon: (props: { active: boolean }) => React.ReactElement;
}[] = [
  {
    tab: "home",
    label: "Home",
    icon: ({ active }) => (
      <svg viewBox="0 0 24 24">
        <path d="M4 11.5 12 5l8 6.5V20a1 1 0 0 1-1 1h-4v-6h-6v6H5a1 1 0 0 1-1-1z" />
      </svg>
    ),
  },
  {
    tab: "team",
    label: "My team",
    icon: ({ active }) => (
      <svg viewBox="0 0 24 24">
        <circle cx="9.2" cy="8" r="3.3" />
        <path d="M3 20a6.2 6.2 0 0 1 12.4 0" />
        <path d="M16 5.2a3.3 3.3 0 0 1 0 5.6M17.6 20a6.3 6.3 0 0 0-1.9-4.4" />
      </svg>
    ),
  },
  {
    tab: "stats",
    label: "Live stats",
    icon: ({ active }) => (
      <svg viewBox="0 0 24 24">
        <rect x="4" y="4" width="16" height="16" rx="4" />
        <path d="M9 15v-3M12 15V9M15 15v-5" />
      </svg>
    ),
  },
  {
    tab: "account",
    label: "Account",
    icon: ({ active }) => (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="3.6" />
        <path d="M5.2 20a6.8 6.8 0 0 1 13.6 0" />
      </svg>
    ),
  },
];

export function TabBar({ active, onNavigate }: Props): React.ReactElement {
  return (
    <div className="app-nav">
      <nav className="ds-navbar" aria-label="Main">
        {TABS.map(({ tab, label, icon: Icon }) => (
          <button
            key={tab}
            type="button"
            className="ds-navbar__item"
            aria-current={active === tab ? "page" : undefined}
            aria-label={label}
            onClick={() => onNavigate(tab)}
          >
            <Icon active={active === tab} />
          </button>
        ))}
      </nav>
    </div>
  );
}
